// src/pages/About.js
import React from 'react';
import ProfileSection from '../components/About/ProfileSection';

const About = () => {
    return (
        <div className="bg-pink-100 min-h-screen">
            <ProfileSection />
        </div>
    );
};

export default About;
